<template>
  <div class="courseDjustment-topbar">
    <div class="courseDjustment-list-topbar">
      <!-- <div class="courseDjustment-search">
        <search :placeholder="placeholder" @search="search" />
      </div> -->
      <!-- <div class="courseDjustment-search">
        <search :placeholder="venueNamePlaceholder" @search="venueNameSearch" />
      </div> -->
      <div class="course-info-button-container">
        <!-- 新增调课 -->
        <el-button
          @click="addCourseAdjustment"
          v-hasPermi="'sc:teacherapplyfor:add'"
          type="success"
          round
          size="medium"
          icon="el-icon-circle-plus-outline"
          >申请调课</el-button
        >
      </div>
    </div>
    <div class="topbar-tabs">
      <div
        class="tab-item"
        :class="currentCourseItem == index ? 'current-item' : ''"
        v-for="(item, index) in statusList"
        :key="index"
        @click="changeCurrentTabItem(index)"
      >
        {{ item.label }}
      </div>
    </div>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";

export default {
  components: {
    search,
  },
  data() {
    return {
      currentCourseItem: 0,
      placeholder: "请输入申请人姓名",
      venueNamePlaceholder: "请输入场馆名称",
    };
  },
  props: {
    statusList: {
      type: Array,
      require: true,
    },
  },
  created() {
    // console.log(this.statusList);
  },
  methods: {
    addCourseAdjustment() {
      this.$emit("addCourseAdjustment", true);
    },
    // 切换状态
    changeCurrentTabItem(tabsIndex) {
      // console.log(tabsIndex);
      this.currentCourseItem = tabsIndex;
      // console.log(this.currentCourseItem);
      // 下标传值
      this.$emit("currentContentIndex", this.currentCourseItem);
    },
    // 搜索
    search(e) {
      // console.log(e);
      // 传搜索词给父
      this.$emit("searchText", e);
    },
    venueNameSearch(e) {
      this.$emit("searchVenueName", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./courseDjustment-topbar.scss";
</style>